/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';

interface INavigateParams {
    url: To | number;
    state?: NavigateOptions;
}

const useNavigateWorkaround = () => {
    const navigate = useNavigate();
    const [navigateParams, setNavigateParams] = useState<INavigateParams | null>(null);

    useEffect(() => {
        if (!navigateParams) return;

        navigate(navigateParams.url as To, navigateParams.state);
        setNavigateParams(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigateParams]);

    const navigateWorkaround = (url: To | number, state?: NavigateOptions) => {
        setNavigateParams({
            url,
            state
        });
    };

    return {
        navigateWorkaround
    };
};

export default useNavigateWorkaround;
